import axios from "axios";

export default {
    state: () => ({
        logoExportStatusList : null
    }),
    mutations: {
        setLogoExportStatusList:function (state,logoExportStatusList){
            state.logoExportStatusList = logoExportStatusList;
        }
    },
    getters: {
        getLogoExportStatusList : state => {
            return state.logoExportStatusList
        }
    },
    actions:{
        loadLogoExportStatusList(context, request){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.get(context.getters.getServiceUrl + "/admin-api/logo/exportStatus?sailId="+request.sailId , {headers})
                .then((response) => {
                    context.commit("setLogoExportStatusList", response.data);
                    return response.data;
                })
        },
        sendToLogo(context, request){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.get(context.getters.getServiceUrl +
                        "/admin-api/logo/sendToLogo?sailId="+request.sailId+"&agencyId="+request.agencyId, {headers})
                .then((response) => {
                    context.dispatch("loadLogoExportStatusList", {sailId:request.sailId})
                    return response.data;
                })
        },
        sendToLogoWebAgency(context, request){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.get(context.getters.getServiceUrl +
                "/admin-api/logo/sendToLogo/webAgency?bookingNumber="+request.bookingNumber, {headers})
                .then((response) => {
                    context.dispatch("loadLogoExportStatusList", {sailId:request.sailId})
                    return response.data;
                })
        }
    }
}

